import { create } from "zustand";

export const singinStore = create((set) => ({
  openSignIn: false,

  setOpenSignIn: (data) => {
    set(() => ({ openSignIn: data }));
  },
}));
